<template>
    <div class="careers-career">
      <div class="careers-career-content">
          <p class="indent">Съществена част от бизнес стратегията на Алкомет са добрите вътрешнокорпоративни отношения и ефективното управление на човешките ресурси. Основни цели в това отношение са повишаване мотивацията и удовлетвореността на служителите и създаване на отлична работна среда, осигуряваща безопасни условия на труд. Компанията зачита човешките права на всеки един служител, оценява индивидуалните му различия и му предоставя възможности за развитие и усъвършенстване, независимо от националност, убеждения, религия, етнически произход и възраст.</p>
      </div>
      <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.careers-career-content {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.careers-career-content > p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto 0;
  text-align: justify;
  width: 60%;
}
@media screen and (max-width: 1000px) {
  .careers-career-content > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/careers/Career.vue